export default {
  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          total: {
            show: true,
            showAlways: false,
            label: 'En tiempo',
            formatter: function (w) {
              let total = 0;
              let number;
              let numberOut = 0;
              w.globals.seriesTotals.forEach(element => {
                total = total + parseInt(element)
              })
              let indice = w.globals.seriesNames.indexOf('Not in Compliance')

              number = total - parseInt(w.globals.seriesTotals[indice])
              if (number != NaN) {
                numberOut = Math.round(number * 100 / total)
              }
              if (indice == -1)(
                numberOut = 100
              )
              return numberOut + '%'
            }
          },
          name: {
            show: true,
            fontSize: '22px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 600,
            color: '#457503',
            offsetY: -10
          },
          value: {
            show: true,
            fontSize: '16px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 400,
            color: undefined,
            offsetY: 16,
            formatter(val, w, label) {
              let total = 0
              w.globals.seriesTotals.forEach(element => {
                total = total + parseInt(element)
              })
              return val
              //return Math.round(val*100/total,-1) + ' %'
            }
          }
        }
      }
    }
  },
  chart: {
    id: 'donut-compliance'
  },
  tooltip: {
    enabled: false
  },
  legend: {
    position: 'bottom',
    markers: {
      fillColors: ['#E5E5E5']
    }
  },
  fill: {
    colors: ['#E5E5E5']
  },
  labels: ['Label'],
  dataLabels: {
    enabled: false
  }
}
